import React from 'react';

const Schedule: React.FC = () => {
  const sangeetEvents = [
    { time: '6.00pm - 7.00pm', title: 'Cocktail Hour', description: 'Pre-celebration drinks and mingling', date: 'March 13th, 2026' },
    { time: '7.00pm - 11.00pm', title: 'Sangeet & Dinner', description: 'Music, dance, and celebrations!', date: 'March 13th, 2026' }
  ];

  const shaadiEvents = [
    { time: '11.30am-1.30pm', title: 'Baraat', description: 'Groom\'s ceremonial procession', date: 'March 14th, 2026' },
    { time: '1:30pm onwards', title: 'Shaadi', description: 'Wedding Ceremony', date: 'March 14th, 2026' },
  ];

  const receptionEvents = [
    { time: '6:30pm - 7:30pm', title: 'Cocktail Hour', description: 'Celebration drinks and canapés', date: 'March 14th, 2026' },
    { time: '7:30pm - 9:00pm', title: 'Reception Dinner', description: 'Grand feast and toasts', date: 'March 14th, 2026' },
    { time: '9:00pm - 11:00pm', title: 'Dancing', description: 'Hit the dance floor', date: 'March 14th, 2026' },
    { time: '11:00pm onwards', title: 'After Party', description: 'Party till the sun comes up', date: 'March 14th, 2026' }
  ];

  return (
    <div className="space-y-24">
      <div className="text-center">
        <h1 className="text-4xl font-display font-medium text-sage-800 mb-4">
          Wedding Schedule
        </h1>
        <div className="elegant-divider"></div>
        <p className="text-sage-grey-600">
          A weekend of unforgettable moments.
        </p>
        
        {/* Photo */}
        <div className="photo-frame max-w-xl mx-auto mt-8 mb-8" style={{width: '85%', height: '400px', overflow: 'hidden', display: 'block', backgroundColor: 'transparent'}}>
          {/* Desktop/Tablet Image */}
          <img 
            src="/images/schedule/3D2A7112_optimized.jpg"
            alt="Shivangi and Ishan" 
            className="w-full h-full object-cover hidden sm:block"
            style={{ objectFit: 'cover', height: '100%', maxWidth: 'none' }}
            loading="lazy"
            decoding="async"
          />
          {/* Mobile Image */}
          <img 
            src="/images/schedule/3D2A7140_optimized.jpg" 
            alt="Shivangi and Ishan" 
            className="w-full h-full object-cover block sm:hidden"
            style={{ objectPosition: 'bottom' }}
            loading="lazy"
            decoding="async"
          />
        </div>
        
      </div>
      
      {/* Sangeet */}
      <div className="glass-card p-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
          <div className="lg:col-span-1">
            <div className="mb-12">
              <h2 className="font-display text-soft-black mb-4 tracking-wide">
                Sangeet
              </h2>
              <p className="text-lg text-text-gray mb-2 tracking-wide">March 13th, 2026</p>
              <p className="text-text-gray uppercase tracking-wider text-sm">Music & Dance Celebration</p>
              <p className="text-text-gray text-sm mt-2">Hotel Chandela, Khajuraho</p>
              <div className="elegant-divider"></div>
            </div>
            
            <div className="space-y-8">
              {sangeetEvents.map((event, index) => (
                <div key={index} className="timeline-minimal">
                  <div className="flex flex-col gap-2">
                    <div className="flex justify-between items-start gap-4">
                      <div className="flex-1">
                        <h3 className="font-display text-soft-black text-lg tracking-wide text-left">
                          {event.title}
                        </h3>
                      </div>
                      <span className="text-text-gray text-sm tracking-wider uppercase bg-light-gray px-3 py-1 text-right flex-shrink-0">
                        {event.time}
                      </span>
                    </div>
                    <p className="text-text-gray text-sm leading-relaxed">
                      {event.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Sangeet Outfit Inspiration */}
          <div className="lg:col-span-1 flex items-center">
            <div className="w-full">
              <div className="w-full flex items-center justify-center" style={{ minHeight: '500px' }}>
                <img 
                  src="/images/wardrobe-planner/sangeet.png" 
                  alt="Sangeet Outfit Inspiration" 
                  className="w-full h-auto object-contain max-w-none"
                  style={{ backgroundColor: 'transparent', maxHeight: '500px' }}
                />
              </div>
              <div className="mt-4 text-center space-y-2">
                <p className="text-sm text-text-gray">
                  <span className="font-medium">Dress Code:</span> Festive Indian / Indo-western. Bright, fun, energetic.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Wedding */}
      <div className="glass-card p-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
          <div className="lg:col-span-1">
            <div className="mb-12">
              <h2 className="font-display text-soft-black mb-4 tracking-wide">
                Wedding
              </h2>
              <p className="text-lg text-text-gray mb-2 tracking-wide">March 14th, 2026</p>
              <p className="text-text-gray uppercase tracking-wider text-sm">Wedding Ceremony</p>
              <p className="text-text-gray text-sm mt-2">Hotel Chandela, Khajuraho</p>
              <div className="elegant-divider"></div>
            </div>
            
            <div className="space-y-8">
              {shaadiEvents.map((event, index) => (
                <div key={index} className="timeline-minimal">
                  <div className="flex flex-col gap-2">
                    <div className="flex justify-between items-start gap-4">
                      <div className="flex-1">
                        <h3 className="font-display text-soft-black text-lg tracking-wide text-left">
                          {event.title}
                        </h3>
                      </div>
                      <span className="text-text-gray text-sm tracking-wider uppercase bg-light-gray px-3 py-1 text-right flex-shrink-0">
                        {event.time}
                      </span>
                    </div>
                    <p className="text-text-gray text-sm leading-relaxed">
                      {event.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Wedding Outfit Inspiration */}
          <div className="lg:col-span-1 flex items-center">
            <div className="w-full">
              <div className="w-full flex items-center justify-center" style={{ minHeight: '500px' }}>
                <img 
                  src="/images/wardrobe-planner/shaadi.png" 
                  alt="Shaadi Outfit Inspiration" 
                  className="w-full h-auto object-contain max-w-none"
                  style={{ backgroundColor: 'transparent', maxHeight: '500px' }}
                />
              </div>
              <div className="mt-4 text-center space-y-2">
                <p className="text-sm text-text-gray">
                  <span className="font-medium">Dress Code:</span> Traditional Indian Formals. Pastel Colours.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Reception */}
      <div className="glass-card p-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
          <div className="lg:col-span-1">
            <div className="mb-12">
              <h2 className="font-display text-soft-black mb-4 tracking-wide">
                Reception
              </h2>
              <p className="text-lg text-text-gray mb-2 tracking-wide">March 14th, 2026</p>
              <p className="text-text-gray uppercase tracking-wider text-sm">Celebrate the happy couple</p>
              <p className="text-text-gray text-sm mt-2">Hotel Chandela, Khajuraho</p>
              <div className="elegant-divider"></div>
            </div>
            
            <div className="space-y-8">
              {receptionEvents.map((event, index) => (
                <div key={index} className="timeline-minimal">
                  <div className="flex flex-col gap-2">
                    <div className="flex justify-between items-start gap-4">
                      <div className="flex-1">
                        <h3 className="font-display text-soft-black text-lg tracking-wide text-left">
                          {event.title}
                        </h3>
                      </div>
                      <span className="text-text-gray text-sm tracking-wider uppercase bg-light-gray px-3 py-1 text-right flex-shrink-0">
                        {event.time}
                      </span>
                    </div>
                    <p className="text-text-gray text-sm leading-relaxed">
                      {event.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Reception Outfit Inspiration */}
          <div className="lg:col-span-1 flex items-center">
            <div className="w-full">
              <div className="w-full flex items-center justify-center" style={{ minHeight: '500px' }}>
                <img 
                  src="/images/wardrobe-planner/reception.png" 
                  alt="Reception Outfit Inspiration" 
                  className="w-full h-auto object-contain max-w-none"
                  style={{ backgroundColor: 'transparent', maxHeight: '500px' }}
                />
              </div>
              <div className="mt-4 text-center space-y-2">
                <p className="text-sm text-text-gray">
                  <span className="font-medium">Dress Code:</span> Black Tie / Formal Indian, Western or Indo-western
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Schedule;